import React, { Component } from 'react';
import "./fullWidthImage.css";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          imageLoaded: false,
          opacity:0,
          imageFade:null
      };
  }

  imageLoaded = () =>{
    console.log("imageLoaded")
    this.setState({
      imageLoaded:true,
      imageFade:"fadeIn"
    })
  }
  removeImage = () =>{
    this.remove();
  }
  render() {
    return (
      <div>
        <img
          src={this.props.image}
          onLoad={this.imageLoaded}
          onError={this.removeImage}
          className={"fade-image full-width " + this.state.imageFade}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/fullWidthImage/index.js